<section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <div >
            <CustomTitle [title]="'msg.misTramites' | translate" [showTag]="false"
                         [styleClass]="'font-principal app-title-page-color font-medium font-23 text-uppercase mt-4 '"/>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.pendientes' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-tramites-historial [tramEstados]="['ACTIVO']" [tramActividadEstados]="['PENDIENTE']"></app-tramites-historial>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.finalizados' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-tramites-historial [tramEstados]="['FINALIZADO','RECHAZADO']" [tramActividadEstados]="['FINALIZADO','REASIGNADO','REABIERTO']"></app-tramites-historial>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
